import { render } from "./PreviewFileLoader.vue?vue&type=template&id=27e00bed&scoped=true"
import script from "./PreviewFileLoader.vue?vue&type=script&lang=js"
export * from "./PreviewFileLoader.vue?vue&type=script&lang=js"

import "./PreviewFileLoader.vue?vue&type=style&index=0&id=27e00bed&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e00bed"]])

export default __exports__